import type {
  EVoyageMissionType,
  IVoyageMissionData,
} from './voyageMissionData'
import { voyageMissionData } from './voyageMissionData-sidecar'
import type { IVoyageMissionWave } from './voyageMissionDataWaves'

export interface IVoyageMission {
  data: IVoyageMissionData
  genMission: Generator<number, number, number>
  waves: IVoyageMissionWave[]
  waveIdx: number
  waveTimer: number
}

export function create(type: EVoyageMissionType) {
  let data = voyageMissionData.find(type)
  let obj: IVoyageMission = {
    data,
    genMission: data.genMission(),
    waves: data.genWaves(),
    waveIdx: 0,
    waveTimer: 0,
  }
  return obj
}
